import React from 'react';
import { ArrowUpRight, MessageCircle } from 'lucide-react';
import styles from './CTABand.module.css';
import Button from '../Button/Button';
import { waLink } from '../../config/site';

export default function CTABand({ title = 'Ready to grow your salon?', text = 'See Hirsta on your own services, staff and prices in a 20-minute demo. We set everything up with you.' }) {
    return (
        <section className={styles.band}>
            <div className={styles.inner}>
                <div>
                    <h2>{title}</h2>
                    <p>{text}</p>
                </div>
                <div className={styles.actions}>
                    <Button to="/demo" variant="light" size="lg" icon={ArrowUpRight}>Grow my salon</Button>
                    <Button href={waLink('Hi, I would like a demo of Hirsta.')} variant="ghostDark" size="lg" icon={MessageCircle}>WhatsApp us</Button>
                </div>
            </div>
        </section>
    );
}
